module.exports = __webpack_public_path__ + "src/assets/img/light_front.4d29462f.svg";